import { connect } from 'react-redux';

import { GET_PLACE_DETAIL, RESET_PLACE_DETAILS } from 'store/place/actionTypes';
import {
  actionGetListChatRoom,
  actionResetListChatRoom,
  actionGetChatRoomDetail,
  actionResetChatRoomDetail,
  actionGetChatRoomMessages,
  actionResetChatRoomMessages,
  actionSendChatMessage,
  actionReceiveChatRoomMessage,
  actionReceiveNewChatRoom,
  actionReadChatRoom,
} from 'store/chat/actions';

import MessagesWithCustomers from './MessagesWithCustomers';

const mapStateToProps = (state) => ({
  isLoadingGetSetting: state.Setting.isLoadingGetSetting,
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,

  setting: state.Setting.setting,
  placeDetail: state.Place.placeDetail,

  isLoadingChatRooms: state.Chat.isLoadingChatRooms,
  chatRooms: state.Chat.chatRooms,
  chatRoomsTotal: state.Chat.chatRoomsTotal,

  isLoadingChatRoomDetail: state.Chat.isLoadingChatRoomDetail,
  chatRoomDetail: state.Chat.chatRoomDetail,

  isLoadingChatMessages: state.Chat.isLoadingChatMessages,
  chatMessages: state.Chat.chatMessages,
  chatMessagesTotal: state.Chat.chatMessagesTotal,

  isSendingChatMessage: state.Chat.isSendingChatMessage,
  sentMessageClientIds: state.Chat.sentMessageClientIds,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionResetPlaceDetail: () => dispatch({
    type: RESET_PLACE_DETAILS,
  }),

  actionGetListChatRoom: (payload) => dispatch(actionGetListChatRoom(payload)),

  actionResetListChatRoom: () => dispatch(actionResetListChatRoom()),

  actionGetChatRoomDetail: (payload) => dispatch(actionGetChatRoomDetail(payload)),

  actionResetChatRoomDetail: () => dispatch(actionResetChatRoomDetail()),

  actionGetChatRoomMessages: (payload) => dispatch(actionGetChatRoomMessages(payload)),

  actionResetChatRoomMessages: () => dispatch(actionResetChatRoomMessages()),

  actionSendChatMessage: (payload) => dispatch(actionSendChatMessage(payload)),

  actionReceiveChatRoomMessage: (payload) => dispatch(
    actionReceiveChatRoomMessage(payload),
  ),

  actionReceiveNewChatRoom: (payload) => dispatch(
    actionReceiveNewChatRoom(payload),
  ),

  actionReadChatRoom: (payload) => dispatch(actionReadChatRoom(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessagesWithCustomers);
